// ticker, duplicated for a seamless loop
var NAMES=['Venus Red Black','Cherry Blossom','Darkness Reigns','Golden Camouflage','Dipped in Gold','Andromeda Gel','Glitter Wave Pink','Pearl White Gel','Chameleon Chrome','French Petal','Syndicate Silver','Red 4 Danger'];
var t=document.getElementById('tick'); if(t){
t.innerHTML=NAMES.concat(NAMES).map(function(n){return '<b>'+n+'</b>';}).join('');}
// nav dropdowns: open on hover, click still works for touch and keyboard
(function(){
  var items = [].slice.call(document.querySelectorAll('.menu > li'))
    .filter(function(li){ return li.querySelector(':scope > button') && li.querySelector('.panel'); });
  if(!items.length) return;
  var hoverable = matchMedia('(hover:hover) and (pointer:fine)').matches;
  var openT = null, shutT = null;
  function closeAll(){ items.forEach(function(o){ o.classList.remove('open'); }); }
  function open(li){ closeAll(); li.classList.add('open'); }

  items.forEach(function(li){
    var b = li.querySelector(':scope > button');

    b.addEventListener('click', function(e){
      e.stopPropagation();
      clearTimeout(openT); clearTimeout(shutT);
      var was = li.classList.contains('open');
      closeAll();
      if(!was) li.classList.add('open');
    });

    if(!hoverable) return;
    li.addEventListener('mouseenter', function(){
      clearTimeout(shutT);
      /* a short wait so sliding across the bar does not flash every panel open */
      var anyOpen = items.some(function(o){ return o.classList.contains('open'); });
      clearTimeout(openT);
      openT = setTimeout(function(){ open(li); }, anyOpen ? 0 : 110);
    });
    li.addEventListener('mouseleave', function(){
      clearTimeout(openT);
      clearTimeout(shutT);
      /* grace period so the mouse can travel from the button into the panel */
      shutT = setTimeout(closeAll, 220);
    });
    /* keyboard: tabbing through the links keeps it open */
    li.addEventListener('focusin', function(){ clearTimeout(shutT); open(li); });
    li.addEventListener('focusout', function(){
      shutT = setTimeout(function(){ if(!li.contains(document.activeElement)) closeAll(); }, 60);
    });
  });

  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeAll(); });
})();


// ---------- hero montage: each panel crossfades its own clips, staggered ----------
(function(){
  var CAP={
    'chrome-row':['Chrome, every shade','The range'],
    'tray-silver':['Silver chrome, close up','The finish'],
    'range':['Mix any five','\u00a39.98'],
    'apply-wood':['Glue on, press down','Ten minutes'],
    'apply':['Any nail glue works','Applying a set'],
    'glitter-tip':['One tip, 12 sizes','A proper fit'],
    'wear':['Up to seven days','The finished set'],
    'detail':['Salon-grade ABS','Never recycled'],
    'apply-silver':['At your own table','No appointment'],
    'differentiate':['Don\u2019t imitate','Bling Art']
  };
  var SRC={
    'chrome-row':'out/m-chrome-row.mp4','tray-silver':'out/m-tray-silver.mp4','range':'out/ba-hero-2-range.mp4',
    'apply-wood':'out/m-apply-wood.mp4','apply':'out/ba-hero-4-apply.mp4','glitter-tip':'out/m-glitter-tip.mp4',
    'wear':'out/ba-hero-5-wear.mp4','detail':'out/ba-hero-3-detail.mp4','apply-silver':'out/m-apply-silver.mp4',
    'differentiate':'out/ba-hero-6-differentiate.mp4'
  };
  var POS={
    'chrome-row':'out/m-chrome-row-poster.jpg','tray-silver':'out/m-tray-silver-poster.jpg','range':'out/ba-hero-2-range-poster.jpg',
    'apply-wood':'out/m-apply-wood-poster.jpg','apply':'out/ba-hero-4-apply-poster.jpg','glitter-tip':'out/m-glitter-tip-poster.jpg',
    'wear':'out/ba-hero-5-wear-poster.jpg','detail':'out/ba-hero-3-detail-poster.jpg','apply-silver':'out/m-apply-silver-poster.jpg',
    'differentiate':'out/ba-hero-6-differentiate-poster.jpg'
  };
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HOLD = 6400;
  document.querySelectorAll('.mpanel[data-clips]').forEach(function(panel, pi){
    var clips = panel.dataset.clips.split(',');
    panel.innerHTML = '<video muted playsinline loop preload="none"></video><video muted playsinline loop preload="none"></video>'
      + '<div class="mpanel__bar"><span></span></div><div class="mpanel__cap"><b></b><i></i></div>';
    var vs = panel.querySelectorAll('video'), v1 = vs[0], v2 = vs[1];
    var cap = panel.querySelector('.mpanel__cap'), bar = panel.querySelector('.mpanel__bar span');
    var k = 0, front = v1;
    function load(v,name){ v.poster = POS[name]; v.src = SRC[name]; v.setAttribute('aria-label', CAP[name][0]); }
    function label(name){
      cap.classList.add('is-swap');
      setTimeout(function(){ cap.querySelector('b').textContent = CAP[name][0];
        cap.querySelector('i').textContent = CAP[name][1]; cap.classList.remove('is-swap'); }, 380);
    }
    function run(ms){ ms = ms || HOLD; bar.classList.remove('is-run'); void bar.offsetWidth;
      bar.style.setProperty('--t', ms + 'ms'); bar.classList.add('is-run'); }
    load(v1, clips[0]); v1.classList.add('is-on'); label(clips[0]);
    if (still) return;
    v1.play().catch(function(){});
    run(HOLD + pi * 1500);
    function next(){
      k = (k + 1) % clips.length;
      var back = (front === v1) ? v2 : v1;
      load(back, clips[k]); back.preload = 'auto'; back.load();
      var done = false;
      function go(){
        if (done) return; done = true;
        back.play().catch(function(){});
        back.classList.add('is-on'); front.classList.remove('is-on');
        var old = front; setTimeout(function(){ old.pause(); }, 1600);
        front = back; label(clips[k]); run();
      }
      back.addEventListener('canplay', go, {once:true});
      setTimeout(go, 2400);
    }
    setTimeout(function(){ setInterval(function(){ if (!document.hidden) next(); }, HOLD); }, pi * 1500);
  });
})();

// ---------- film: click to play, pause when off screen ----------
(function(){
  document.querySelectorAll('.vwrap').forEach(function(w){
    var v=w.querySelector('video'), b=w.querySelector('.vbtn');
    if(!v||!b) return;
    b.addEventListener('click',function(){
      if(v.paused){ v.play().then(function(){w.classList.add('playing');}).catch(function(){}); }
      else { v.pause(); w.classList.remove('playing'); }
    });
    v.addEventListener('pause',function(){ w.classList.remove('playing'); });
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(!e.isIntersecting){ var v=e.target.querySelector('video'); if(v&&!v.paused) v.pause(); } });
    },{threshold:0.1});
    document.querySelectorAll('.vwrap').forEach(function(w){ io.observe(w); });
  }
})();

// ---------- header lifts once you scroll ----------
(function(){
  var h=document.querySelector('header'); if(!h) return;
  var tick=false;
  addEventListener('scroll',function(){
    if(tick) return; tick=true;
    requestAnimationFrame(function(){ h.classList.toggle('stuck', scrollY>12); tick=false; });
  },{passive:true});
})();

// ---------- motion: reveal on scroll ----------
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-rev], .shapeshot, .heroshot');
  if(reduce || !('IntersectionObserver' in window)){
    targets.forEach(function(t){ t.classList.add('seen'); }); return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('seen'); io.unobserve(en.target); }
    });
  },{threshold:0.14, rootMargin:'0px 0px -8% 0px'});
  targets.forEach(function(t){ io.observe(t); });
})();

// ---------- mix five picker (real ladder prices only) ----------


/* shape panels: row click swaps the stage shot and its copy */
document.querySelectorAll('.pk').forEach(function(pk){
  var rows  = Array.prototype.slice.call(pk.querySelectorAll('.pr[data-i]'));
  var shots = Array.prototype.slice.call(pk.querySelectorAll('.pk__img'));
  var name  = pk.querySelector('.pk__name');
  var desc  = pk.querySelector('.pk__desc');
  var buy   = pk.querySelector('.pk__buy');
  function show(i){
    rows.forEach(function(r,k){
      r.classList.toggle('is-on', k === i);
      r.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
    shots.forEach(function(s,k){ s.classList.toggle('is-on', k === i); });
    var r = rows[i];
    name.textContent = r.getAttribute('data-name');
    desc.textContent = r.getAttribute('data-desc');
    buy.setAttribute('href', r.getAttribute('data-href'));
  }
  rows.forEach(function(r,i){
    r.addEventListener('click', function(){ show(i); });
    r.addEventListener('mouseenter', function(){ show(i); });
  });
});

/* the wall only loads and plays what is actually on screen */
(function(){
  var vids = Array.prototype.slice.call(document.querySelectorAll('.wt__v'));
  if (!vids.length) return;
  if (!('IntersectionObserver' in window)) {
    vids.forEach(function(v){ v.src = v.getAttribute('data-src'); v.play().catch(function(){}); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src) v.src = v.getAttribute('data-src');
        v.play().catch(function(){});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, {rootMargin: '140px 0px', threshold: 0.15});
  vids.forEach(function(v){ io.observe(v); });
})();

/* hero films load and run only while the hero is on screen */
(function(){
  var hero=document.getElementById('bhero'); if(!hero) return;
  var vs=[].slice.call(hero.querySelectorAll('video')); if(!vs.length) return;
  var still=matchMedia('(prefers-reduced-motion: reduce)').matches;
  function play(on){
    vs.forEach(function(v){
      if(v.offsetParent===null) return;
      if(!v.src) v.src=v.getAttribute('data-src');
      if(on && !still){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
      else v.pause();
    });
  }
  /* the hero is above the fold, so start it rather than waiting for an
     intersection callback; the observer only pauses it once it scrolls away */
  play(true);
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(e){
      if(!e[0].isIntersecting) play(false); else play(true);
    },{threshold:0}).observe(hero);
  }
  /* some browsers refuse the first play() before any user gesture even when muted,
     so retry once the page is fully loaded */
  addEventListener('load', function(){ play(true); });
})();

/* mobile drawer: built from the desktop menu so the links can never diverge */
(function(){
  var mnav = document.getElementById('mnav');
  var burger = document.querySelector('.burger');
  if (!mnav || !burger) return;
  var groups = mnav.querySelector('.mnav__groups');

  Array.prototype.forEach.call(document.querySelectorAll('.menu > li'), function(li, i){
    var btn = li.querySelector(':scope > button');
    if (!btn) return;
    var label = btn.textContent.trim();
    var links = li.querySelectorAll('.panel .links a');
    var g = document.createElement('div');
    g.className = 'mg';
    if (!links.length) {
      /* a top level item that is just a link, e.g. Salon */
      var href = (btn.getAttribute('onclick') || '').replace(/.*'(.*)'.*/, '$1') || '#';
      g.className = 'mg mg--flat';
      g.innerHTML = '<a class="mg__b" href="' + href + '">' + label + '</a>';
    } else {
      var html = '<button class="mg__b" type="button" aria-expanded="false">' + label + '<i>+</i></button>'
               + '<div class="mg__links">';
      Array.prototype.forEach.call(links, function(a){
        html += '<a href="' + a.getAttribute('href') + '">' + a.innerHTML + '</a>';
      });
      g.innerHTML = html + '</div>';
    }
    groups.appendChild(g);
  });

  groups.addEventListener('click', function(e){
    var b = e.target.closest('.mg__b');
    if (!b || b.tagName !== 'BUTTON') return;
    var g = b.parentNode, open = g.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function setOpen(on){
    burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) {
      mnav.hidden = false;
      requestAnimationFrame(function(){ mnav.classList.add('is-on'); });
      document.body.style.overflow = 'hidden';
    } else {
      mnav.classList.remove('is-on');
      document.body.style.overflow = '';
      setTimeout(function(){ if(!mnav.classList.contains('is-on')) mnav.hidden = true; }, 340);
    }
  }
  burger.addEventListener('click', function(){
    setOpen(burger.getAttribute('aria-expanded') !== 'true');
  });
  mnav.addEventListener('click', function(e){
    if (e.target.closest('[data-mnav-close]') || e.target.closest('a')) setOpen(false);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') setOpen(false);
  });
  /* if the window grows back to desktop, make sure nothing is left locked */
  addEventListener('resize', function(){
    if (innerWidth > 900 && burger.getAttribute('aria-expanded') === 'true') setOpen(false);
  });
})();



/* read more: only clamps blocks that are actually too long, so no pointless buttons */
(function(){
  document.querySelectorAll('[data-more]').forEach(function(box){
    var inner = box.querySelector('.more__in');
    if (!inner) return;
    var lines = parseInt(box.getAttribute('data-more'), 10) || 3;
    box.style.setProperty('--lines', lines);
    /* measure before clamping: if it already fits, leave it alone */
    var full = inner.scrollHeight;
    var lh = parseFloat(getComputedStyle(inner).lineHeight) || 26;
    if (full <= lh * (lines + 0.6)) return;

    box.classList.add('more--on');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'more__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', inner.id || (inner.id = 'more-' + Math.random().toString(36).slice(2, 8)));
    btn.innerHTML = '<span>Read more</span><i aria-hidden="true"></i>';
    box.appendChild(btn);

    btn.addEventListener('click', function(){
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('span').textContent = open ? 'Show less' : 'Read more';
      if (!open) {
        var top = box.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({top: top - 90, behavior: 'smooth'});
      }
    });
  });
})();

/* section 2: chip picks the shape, the stage links through to that collection */
(function(){
  var sp = document.getElementById('shapes'); if(!sp) return;
  var chips  = [].slice.call(sp.querySelectorAll('.sp__chip'));
  var stages = [].slice.call(sp.querySelectorAll('.sp__stage'));
  var panels = [].slice.call(sp.querySelectorAll('.sp__panel'));
  if(!chips.length) return;
  function show(i){
    chips.forEach(function(c,k){
      c.classList.toggle('is-on', k===i);
      c.setAttribute('aria-selected', k===i ? 'true' : 'false');
    });
    stages.forEach(function(s,k){ s.classList.toggle('is-on', k===i); });
    panels.forEach(function(p,k){ if(k===i) p.removeAttribute('hidden'); else p.setAttribute('hidden',''); });
  }
  chips.forEach(function(c,i){
    c.addEventListener('click', function(){ show(i); });
  });
  sp.addEventListener('keydown', function(e){
    var at = chips.indexOf(document.activeElement);
    if(at < 0) return;
    if(e.key === 'ArrowRight'){ e.preventDefault(); var n=(at+1)%chips.length; chips[n].focus(); show(n); }
    if(e.key === 'ArrowLeft'){ e.preventDefault(); var p=(at-1+chips.length)%chips.length; chips[p].focus(); show(p); }
  });
})();

/* salon packs: shape x finish picks one of the eight real products */
(function(){
  var t = document.getElementById('salon'); if(!t) return;
  var DATA = {"almond-natural": {"img": "site-img/salon/almond-natural.jpg", "href": "/products/false-nails-by-bling-art-360-stiletto-almond-long-natural-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, almond and stiletto, natural beige"}, "almond-transparent": {"img": "site-img/salon/almond-transparent.jpg", "href": "/products/false-nails-by-bling-art-360-stiletto-almond-long-transparent-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, almond and stiletto, clear"}, "squoval-natural": {"img": "site-img/salon/squoval-natural.jpg", "href": "/products/false-nails-by-bling-art-360-squoval-long-natural-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, squoval, natural beige"}, "squoval-transparent": {"img": "site-img/salon/squoval-transparent.jpg", "href": "/products/false-nails-by-bling-art-360-squoval-long-transparent-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, squoval, clear"}, "oval-natural": {"img": "site-img/salon/oval-natural.jpg", "href": "/products/false-nails-by-bling-art-360-oval-medium-natural-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, oval, natural beige"}, "oval-transparent": {"img": "site-img/salon/oval-transparent.jpg", "href": "/products/false-nails-by-bling-art-360-oval-medium-transparent-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, oval, clear"}, "ballerina-natural": {"img": "site-img/salon/ballerina-natural.jpg", "href": "/products/false-nails-by-bling-art-360-coffin-ballerina-long-natural-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, ballerina and coffin, natural beige"}, "ballerina-transparent": {"img": "site-img/salon/ballerina-transparent.jpg", "href": "/products/false-nails-by-bling-art-360-coffin-ballerina-long-transparent-acrylic-fake-nail-tips", "cap": "Salon Bulk Pack, ballerina and coffin, clear"}};
  var shape = 'almond', fin = 'natural';
  var shots = [].slice.call(t.querySelectorAll('.trade__img'));
  var cap   = t.querySelector('[data-cap]');
  var buy   = t.querySelector('.trade__buy');
  function apply(){
    var k = shape + '-' + fin, d = DATA[k];
    if(!d) return;
    shots.forEach(function(im){ im.classList.toggle('is-on', im.getAttribute('data-k') === k); });
    cap.textContent = d.cap;
    buy.setAttribute('href', d.href);
  }
  t.querySelectorAll('.trade__chips').forEach(function(group){
    var which = group.getAttribute('data-group');
    group.addEventListener('click', function(e){
      var b = e.target.closest('.tchip'); if(!b) return;
      group.querySelectorAll('.tchip').forEach(function(o){ o.classList.remove('is-on'); });
      b.classList.add('is-on');
      if(which === 'shape') shape = b.getAttribute('data-shape');
      else fin = b.getAttribute('data-fin');
      apply();
    });
  });
  apply();
})();
